import React, { useState, useEffect } from "react";
import { Typography, Paper } from "@material-ui/core";
import Grid from "@material-ui/core/Grid";
import { makeStyles } from "@material-ui/core/styles";
import LocalAtmIcon from '@material-ui/icons/LocalAtm';
import { Link, useLocation } from "react-router-dom";
import AddCircleOutlineIcon from "@material-ui/icons/AddCircleOutline";
import EditIcon from "@material-ui/icons/Edit";
import TextField from '../../biztran_controls/Input';
import CloseIcon from "@material-ui/icons/Close";
import SwapHorizIcon from '@material-ui/icons/SwapHoriz';
import BiztranControls from "../../biztran_controls/BiztranControls";
import AlertDialog from "../../biztran_controls/AlertDialog";
import UseFetchData from "../../../hooks/UseFetchData";
import ModalFrame from "../../biztran_controls/Modal_Frame";
import CreateSalesOrder from "./CreateSalesOrder";
import axios from 'axios';
import { REPORT_URL } from "../../../Global";
import SendEmail from "../MessageCenter/SendEmail";
// import Loader from "../../biztran_controls/Loader";
import { useHistory } from 'react-router-dom';


const SOHeaderView = ({ SOMainData, SalesOrderID, PopulateData }) => {
  // debugger;
  const classes = useStyles();
  const [isOpen, setOpen] = useState(false);
  const [Mode, setMode] = useState('');
  const [SOID, SetSOID] = useState('');
  const [viewPath, setViewPath] = useState('');
  const [viewPathPI, setViewPathPI] = useState('');
  const [SONo, setSONo] = useState("");
  const [Company, setCompany] = useState("");
  const [SODate, setSODate] = useState("");
  const [Email, setEmail] = useState([]);
  const [EmailData, setEmailData] = useState([]);
  const [EmailCount, setEmailCount] = useState(1);
  const [isMailOpen, setMailOpen] = useState(false);
  const [AccountID, setAccountID] = useState('');
  const [Lead, setLead] = useState("");
  const [Quotation, setQuotation] = useState("");
  const [AccountName, setAccountName] = useState("");
  const [Contact, setContact] = useState("");
  const [ContactNo, setContactNo] = useState("");
  const [PONumber, setPONumber] = useState("");
  const [LeadSource, setLeadSource] = useState("");
  const [SOType, setSOType] = useState("");
  const [BillAddress, setBillAddress] = useState("");
  const [BillCountry, setBillCountry] = useState("");
  const [BillState, setBillState] = useState("");
  const [BillCity, setBillCity] = useState("");
  const [BillPINCode, setBillPINCode] = useState("");
  const [isChecked, setIsChecked] = useState(false);
  const [isNoChecked, setisNoChecked] = useState(false);
  const [ShipAddress, setShipAddress] = useState("");
  const [DisablePIPrint, setDisablePIPrint] = useState(false);
  const [DisableisNoChecked, setDisableisNoChecked] = useState(false);
  // const [EnablePIPrint, setEnablePIPrint] = useState(false);
  const [ShipCity, setShipCity] = useState("");
  const [ShipPINCode, setShipPINCode] = useState("");
  const [ShipCountry, setShipCountry] = useState("");
  const [ShipState, setShipState] = useState("");
  const [HandledBy, setHandledBy] = useState("");
  const [GeneratedBy, setGeneratedBy] = useState("");
  const [CreatedBy, setCreatedBy] = useState("");
  const [TotalAmount, setTotalAmount] = useState("");
  const [isOpenConvert, setOpenConvert] = useState(false);
  const [DisableConvetbtn, setDisableConvetbtn] = useState(false);
  const [Response, fetchData] = UseFetchData();
  const [cmbPaymentTermsOptions, setcmbPaymentTermsOptions] = useState([]);
  const [cmbAccountData, setcmbAccountData] = useState([]);
  const [cmbLeadSourceData, setcmbLeadSourceData] = useState([]);
  const [cmbCountryData, setcmbCountryData] = useState([]);
  const [cmbCompanyData, setcmbCompanyData] = useState([]);
  const [ComboDataResponse, fetchComboData] = UseFetchData();
  const [loading, setLoading] = useState(true);
  const location = useLocation();
  const history = useHistory();
  // const [pageName, setPageName] = useState('Headerview');
  const MyContext = React.createContext();

  // const queryParams = new URLSearchParams(location.search);
  const [QuotationID, setQuotationID] = useState("");
  // const QID = location.state.QuotationID;
  var Account = location.state.AccountName;
  var BCity = location.state.City;
  var PID = location.state.ProductID;
  var Mc = location.state.ModelNo;
  var Sno = location.state.SalesOrderNo;
  // var SM = location.state.SearchMode;

  // const myData = {
  //   BCity,
  //   Account,
  //   PID,
  //   Mc, Sno,
  // };
  // sessionStorage.setItem("BCity", BCity);

  // history.push('/SalesOrder', { Account });


  const handleOpenModal = () => {
    setOpen(true);
    SetSOID(SalesOrderID);
    setMode('Update');
  };

  const OpenModal = () => {
    setOpen(true);
    SetSOID("");
    setMode('Insert');
  };

  const handleOpenModals = () => {
    setAccountID('');
    var ToEmail = [];
    console.log(Email)
    // debugger;
    // setEmailCount(EmailID.length)
    ToEmail.push(Email);
    setEmailData(ToEmail);
    setMailOpen(true);
  }


  // const PopulateData = () => {
  //   // const pageName = 'Headerview'; // set the value to send
  //   // localStorage.setItem('pageName', pageName); // store the value in localStorage
  //   // window.location.href = '/SalesOrder'; // navigate to the destination page
  //   history.push('/SalesOrder', { Account });
  // }



  useEffect(() => {

    GetComboData();
  }, []);

  const GetComboData = () => {
    fetchComboData("SalesOrder/ComboDataHeaderView");
  };

  useEffect(() => {
    if (ComboDataResponse !== undefined) {
      if (
        ComboDataResponse["Account"] !== undefined &&
        ComboDataResponse["LeadSource"] !== undefined &&
        ComboDataResponse["Country"] !== undefined &&
        ComboDataResponse["Company"] !== undefined
        // ComboDataResponse["PaymentTerms"] !== undefined
      ) {
        setcmbAccountData(ComboDataResponse["Account"]);
        setcmbLeadSourceData(ComboDataResponse["LeadSource"]);
        setcmbCountryData(ComboDataResponse["Country"]);
        setcmbCompanyData(ComboDataResponse["Company"]);
        // PaymentTermsData(ComboDataResponse["PaymentTerms"]);
        // if (props.OpportunityID !== "") {
        //   BillStatecmbData("");
        //   ShipStatecmbData("");
        //   setMode("Update");
        // } else {
        //   setMode("Insert");
        // }
      }
    }
  }, [ComboDataResponse]);


  const Openurl = async () => {
    debugger;
    // var SalesOrderID = SalesOrderID == undefined ? SOMainData[0].id : SalesOrderID;
    if (SalesOrderID != undefined) {
      axios.post('http://pmcrm.rpt.biztran.in/WebService.asmx/PrintReport', {
        PKID: SalesOrderID,
        Type: 'OrderAccceptance'
      })
        .then(await function (response) {
          // debugger;
          console.log(response.data);
          setViewPath(response.data);
          window.open(response.data);
        })
        .catch(function (error) {
          alert('error to print')
          console.log(error);
        });
    }
    else {
      axios.post('http://pmcrm.rpt.biztran.in/WebService.asmx/PrintReport', {
        PKID: SOMainData[0].id,
        Type: 'OrderAccceptance'
      })
        .then(await function (response) {
          // debugger;
          console.log(response.data);
          setViewPath(response.data);
          window.open(response.data);
        })
        .catch(function (error) {
          alert('error to print')
          console.log(error);
        });
    }
  }


  useEffect(() => {
    if (isChecked) {
      setDisableisNoChecked(true);
    } else {
      setDisableisNoChecked(false);
    }
  });

  useEffect(() => {
    if (isNoChecked) {
      alert("Not Ready To Process!")
      setDisablePIPrint(true);
    } else {
      setDisablePIPrint(false);
    }
  });


  // const OpenPI = () => {
  //  // debugger;
  //   axios.post(REPORT_URL, {
  //     PKID: SalesOrderID,
  //     Type: 'ProformaInvoiceExport'
  //   })
  //     .then(function (response) {
  //       setViewPath(response.data);
  //     })
  //     .catch(function (error) {
  //       console.log(error);
  //     });
  //   window.open(viewPath);
  // }
  // const Page1 = () => {
  //   const value = useContext(MyContext);

  //   return (
  //     <Link to="/page2" />
  //   );
  // }


  const OpenPI = async () => {
    debugger;
    // var SalesOrderID = SalesOrderID == undefined ? SOMainData[0].id : SalesOrderID;
    // }
    if (SalesOrderID != undefined) {

      axios.post('http://pmcrm.rpt.biztran.in/WebService.asmx/PrintReport', {
        PKID: SalesOrderID,
        Type: 'ProformaInvoiceExport'
      })
        .then(await function (response) {
          console.log(response.data);
          setViewPath(response.data);
          window.open(response.data);
        })
        .catch(function (error) {
          alert('error to print')
          console.log(error);
        });
    }
    else {
      axios.post('http://pmcrm.rpt.biztran.in/WebService.asmx/PrintReport', {
        PKID: SOMainData[0].id,
        Type: 'ProformaInvoiceExport'
      })
        .then(await function (response) {
          console.log(response.data);
          setViewPath(response.data);
          window.open(response.data);
        })
        .catch(function (error) {
          alert('error to print')
          console.log(error);
        });
    }
  }


  useEffect(() => {
    // debugger;
    if (SOMainData !== undefined && SOMainData.length > 0) {
      setCreatedBy(SOMainData[0].CreatedBy);
      setAccountName(SOMainData[0].AccountName);
      setTotalAmount(SOMainData[0].TotalAmount);
      setQuotation(SOMainData[0].QuotationNo === null ? "" : SOMainData[0].QuotationNo);
      setQuotationID(SOMainData[0].QuotationID === null ? "" : SOMainData[0].QuotationID);
      setSONo(SOMainData[0].SalesOrderNo);
      setCompany(SOMainData[0].CompanyCode);
      setSODate(SOMainData[0].SalesOrderDate);
      setLead(SOMainData[0].LeadNo);
      setContact(SOMainData[0].ContactName);
      setEmail(SOMainData[0].Email === null ? "" : SOMainData[0].Email);
      setContactNo(SOMainData[0].Mobile);
      setPONumber(SOMainData[0].PONumber);
      setLeadSource(SOMainData[0].LeadSource);
      setSOType(SOMainData[0].SalesOrderType);
      setHandledBy(SOMainData[0].HandledBy);
      setGeneratedBy(SOMainData[0].GeneratedBy);
      setBillAddress(SOMainData[0].BillAddress1 + " " + SOMainData[0].BillAddress2);
      setBillCity(SOMainData[0].BillCity === null ? "" : SOMainData[0].BillCity);
      setBillState(SOMainData[0].BillState === null ? "" : SOMainData[0].BillState);
      setBillCountry(SOMainData[0].BillCountry === null ? "" : SOMainData[0].BillCountry);
      setBillPINCode(SOMainData[0].BillPINCode === null ? "" : SOMainData[0].BillPINCode);
      setShipAddress(SOMainData[0].ShipAddress1 + " " + SOMainData[0].ShipAddress2);
      setShipCity(SOMainData[0].ShipCity === null ? "" : SOMainData[0].ShipCity);
      setShipState(SOMainData[0].ShipStateName === null ? "" : SOMainData[0].ShipStateName);
      setShipCountry(SOMainData[0].ShipCountry === null ? "" : SOMainData[0].ShipCountry);
      setShipPINCode(SOMainData[0].ShipPINCode === null ? "" : SOMainData[0].ShipPINCode);

    }
  }, [SOMainData]);

  return (
    <Paper elevation={3}>
      {/* {
        !loading && (
          <div style={{
            position: 'fixed',
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            backgroundColor: 'rgba(0, 0, 0, 0.5)',
            zIndex: 10,
          }}>
            <Loader />
          </div>
        )
      } */}
      <Typography className={classes.headertext} noWrap>
        <LocalAtmIcon style={{ fontSize: 36 }} />
        Sales Order
        <div style={{ width: "70%" }}>
          <div style={{ float: "right", marginTop: -3 }}>
            {/* 10-feb - change */}
            <Grid container direction="row" >
              {/* <MyContext.Provider value={Account}> */}
              {/* <Page1 /> */}
              {/* Page1(); */}
              {/* </MyContext.Provider> */}
              {/* <Grid item  >
                <Link
                  style={{ textDecoration: "none" }}
                  to={{
                    pathname: "/SalesOrder",
                    state: { Account, BCity, PID, Mc, Sno },
                    // pageName: "header",
                  }}
                >
                  <BiztranControls.Button text={"Prev"} />
                </Link>
              </Grid> */}
              <Grid item  >
                <BiztranControls.Button
                  text="PIPrint"
                  disabled={DisablePIPrint}
                  onClick={() => {
                    OpenPI();
                  }}
                />
              </Grid>
              <Grid item >
                <BiztranControls.Button
                  text="OAPrint"
                  onClick={() => {
                    Openurl();
                  }}
                />
              </Grid>
              <Grid item  >
                <BiztranControls.Button
                  text="EDIT"
                  startIcon={<EditIcon />}
                  onClick={() => {
                    handleOpenModal();
                  }} />
              </Grid>
              <Grid item xs={12} sm={1} md={1} lg={1} xl={1} >
                <TextField id="outlined-basic" label="EmailID" variant="outlined" value={Email}
                  onChange={(e) => setEmail(e.target.value)} />
                <BiztranControls.Button
                  text="SendEmail"
                  startIcon={<AddCircleOutlineIcon />}
                  onClick={() => {
                    handleOpenModals();
                  }}
                />
              </Grid>
            </Grid>
            {/* <BiztranControls.Button
              text="Add New"
              startIcon={<AddCircleOutlineIcon />}
              onClick={() => {
                OpenModal();
              }}
            /> */}

          </div>
        </div>
      </Typography>
      <Grid spacing={1} container style={{ marginTop: 7, paddingLeft: 10 }}>
        <Grid item xs={12} container direction="row">
          <Grid item xs={3} container direction="row">
            <h5 style={{ width: 100 }}>SalesOrder No:</h5>
            <h5 style={{ color: "#0096FF" }}>{SONo + " - " + SODate}</h5>
          </Grid>
          {/* <Grid item xs={3} container direction="row">
            <h5 style={{ width: 110 }}>Status:</h5>
            <h5 style={{ color: "green" }}>{OpportunityStage}</h5>
          </Grid> */}
          <Grid item xs={3} container direction="row">
            <h5 style={{ width: 100 }}>Company:</h5>
            <h5 style={{ color: "#0096FF" }}>{Company}</h5>
          </Grid>
          <Grid item xs={3} container direction="row">
            <h5 style={{ width: 110 }}>Quotation:</h5>
            <h5 style={{ color: "#0096FF" }}>{Quotation}</h5>
          </Grid>
          <Grid item xs={3} container direction="row">
            <h5 style={{ width: 100 }}>Lead Source:</h5>
            <h5 style={{ color: "#0096FF" }}>{LeadSource}</h5>
          </Grid>
        </Grid>
        <Grid item xs={12} container direction="row">
          <Grid item xs={6} container direction="row">
            <h5 style={{ width: 100 }}>Account Name:</h5>
            <h5 style={{ color: "#0096FF" }}>{AccountName}</h5>
          </Grid>
          <Grid item xs={3} container direction="row">
            <h5 style={{ width: 100 }}>Contact:</h5>
            <h5 style={{ color: "#0096FF" }}>{Contact}</h5>
          </Grid>
          <Grid item xs={3} container direction="row">
            <h5 style={{ width: 110 }}>Contact No:</h5>
            <h5 style={{ color: "#0096FF" }}>{ContactNo}</h5>
          </Grid>

        </Grid>
        <Grid item xs={12} container direction="row">
          <Grid item xs={3} container direction="row">
            <h5 style={{ width: 100 }}>Generated By:</h5>
            <h5 style={{ color: "#0096FF" }}>{GeneratedBy}</h5>
          </Grid>
          <Grid item xs={3} container direction="row">
            <h5 style={{ width: 100 }}>Handled By:</h5>
            <h5 style={{ color: "#0096FF" }}>{HandledBy}</h5>
          </Grid>
          <Grid item xs={3} container direction="row">
            <h5 style={{ width: 110 }}>PO Ref:</h5>
            <h5 style={{ color: "#0096FF" }}>{PONumber}</h5>
          </Grid>
          <Grid item xs={3} container direction="row">
            <label>Ready To Process :</label>
            <div style={{ paddingLeft: 10 }} >
              <label>Yes </label>
              <input
                type="checkbox"
                name="chkbox"
                // label="YES"
                checked={isChecked}
                onChange={(e) => {
                  setIsChecked(e.target.checked);
                }}
              ></input>
            </div>
            <div style={{ paddingLeft: 10 }}>
              <label>No </label>
              <input
                type="checkbox"
                name="chkbox"
                label="NO"
                checked={isNoChecked}
                disabled={DisableisNoChecked}
                onChange={(e) => {
                  setisNoChecked(e.target.checked);
                }}
              ></input>
            </div>
          </Grid>
          <Grid item xs={3} container direction="row">
          </Grid>
        </Grid>
        <Grid item xs={12} container direction="row">
          <Grid item xs={3} container direction="row">
            <h5 style={{ width: 100 }}>Billing Address:</h5>
            <h5 style={{ color: "#0096FF" }}>{BillAddress}</h5>
            <Grid item xs={3} container direction="row">
              <h5 style={{ width: 100, color: "#0096FF" }}> {BillCity + " " + BillState + " " + BillCountry + " " + BillPINCode}</h5></Grid>
          </Grid>
          <Grid item xs={3} container direction="row">
            <h5 style={{ width: 120 }}>Shipping Address:</h5>
            <h5 style={{ color: "#0096FF" }}>{ShipAddress}</h5>
            <Grid item xs={3} container direction="row">
              <h5 style={{ width: 100, color: "#0096FF" }}> {ShipCity + " " + ShipState + " " + ShipCountry + " " + ShipPINCode}</h5></Grid>
          </Grid>
        </Grid>
      </Grid>
      <ModalFrame
        title="Sales Order Details"
        maxWidth="md"
        isOpen={isOpen}
        setOpen={setOpen}
      >
        <CreateSalesOrder
          SalesOrderID={SOID}
          setOpen={setOpen}
          SalesOrderMainData={SOMainData}
          Mode={Mode}
          PopulateData={PopulateData}
          QuotationID={QuotationID}
          cmbAccountData={cmbAccountData}
          cmbCompanyData={cmbCompanyData}
          cmbLeadSourceData={cmbLeadSourceData}
          cmbCountryData={cmbCountryData}
          cmbPaymentTermsOptions={cmbPaymentTermsOptions}
        />
      </ModalFrame>
      <ModalFrame
        title="SendEmail"
        maxWidth="md"
        isOpen={isMailOpen}
        headerAlign="center"
        setOpen={setMailOpen}
      >
        <SendEmail
          AccountID={AccountID}
          setOpen={setMailOpen}
          EmailData={EmailData}
          EmailCount={1}
        //getByIDData={PopulateData}
        />
      </ModalFrame>
    </Paper>
  );
};

const useStyles = makeStyles((theme) => ({
  header: {
    width: "100%",
    background: "#e6d8d8", //theme.palette.tertiary.gradient,
    color: "#3d3d3d",
    height: "2.7rem",
    fontSize: "1.8rem",
    marginTop: "4.2rem",
    display: "flex",
    flexDirection: "row",
  },
  headertext: {
    background: "#e6d8d8", //theme.palette.tertiary.gradient,
    color: "#3d3d3d",
    height: "2.7rem",
    fontSize: "1.8rem",
    marginTop: "4.3rem",
    display: "flex",
    flexDirection: "row",
  },
  headerCmn: {
    background: "#e6d8d8", //theme.palette.tertiary.gradient,
    color: "#3d3d3d",
    height: "2rem",
    fontSize: "1rem",
    display: "flex",
    flexDirection: "row",
    margin: "0.3rem",
    fontWeight: "bold",
  },
}));

export default SOHeaderView;
